import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import QuestionList from '../QuestionList/QuestionList';
import './MyQuestions.css';
import { BASE_URL } from '../../utils/api';
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const MyQuestions = () => {
  const [myQuestions, setMyQuestions] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMyQuestions = async () => {
      const token = localStorage.getItem('accessToken');
      console.log('Token in MyQuestions:', token);
      if (!token) {
        console.log('No token found, redirecting to login');
        navigate('/login');
        return;
      }

      try {
        console.log('Fetching my questions from API...');
        const response = await fetch(`${BASE_URL}/questions/my-questions/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        console.log('Response status:', response.status);
        if (!response.ok) {
          console.log('Response not OK:', response.status);
          if (response.status === 401) {
            localStorage.removeItem('accessToken');
            navigate('/login');
          } else {
            setError('Failed to fetch questions. Please try again.');
          }
          return;
        }
        const data = await response.json();
        console.log('Fetched data:', data);
        setMyQuestions(data);
      } catch (err) {
        console.error('Fetch error:', err);
        setError('An error occurred while fetching questions.');
        navigate('/login');
      }
    };

    fetchMyQuestions();
  }, [navigate]);

  return (
    <div className="my-questions-container">
      <h2 className="my-questions-title">My Questions</h2>
      {error ? (
        <p className="error-message">{error}</p>
      ) : (
        <QuestionList questions={myQuestions} showAskButton={false} />
      )}
    </div>
  );
};

export default MyQuestions;